import React from "react";

const SkeletonCard = ({ index }) => (
  <div className="creative-skeleton-card" style={{ animationDelay: `${index * 0.05}s` }}>
    <div className="creative-skeleton-card__thumbnail" />
    <div className="creative-skeleton-card__info">
      <div className="creative-skeleton-card__name" />
      <div className="creative-skeleton-card__meta" />
    </div>
  </div>
);

const SkeletonRow = ({ index }) => (
  <div className="creative-skeleton-row" style={{ animationDelay: `${index * 0.05}s` }}>
    <div className="creative-skeleton-row__checkbox" />
    <div className="creative-skeleton-row__thumbnail" />
    <div className="creative-skeleton-row__content">
      <div className="creative-skeleton-row__name" />
      <div className="creative-skeleton-row__meta" />
    </div>
  </div>
);

const SkeletonGrid = ({ viewMode, count = 8 }) => {
  const items = Array.from({ length: count }, (_, i) => i);

  if (viewMode === "list") {
    return (
      <div className="creative-library__list">
        {items.map((i) => (
          <SkeletonRow key={i} index={i} />
        ))}
      </div>
    );
  }

  return (
    <div className="creative-library__grid">
      {items.map((i) => (
        <SkeletonCard key={i} index={i} />
      ))}
    </div>
  );
};

export default SkeletonGrid;
